import { Button, Stack, TextField, Typography } from '@mui/material';
import { ChangeEvent, useCallback } from 'react';

import { CSAT_FOLLOW_UP_TEXT, CSAT_LOW_SCORE_CEILING } from './constants';

import { useMember } from 'modules/common/queries/member';
import ScheduleCall from 'modules/IMC/MessageCenter/components/MessageCenterFooter/ScheduleCall';

interface CSATFollowUpProps {
    score: number;
    comment: string;
    onCommentChange: (value: string) => void;
    onSubmit: () => void;
    isSubmitting: boolean;
}

export default function CSATFollowUp({
    score,
    comment,
    onCommentChange,
    onSubmit,
    isSubmitting,
}: Readonly<CSATFollowUpProps>) {
    const { data: member } = useMember();

    const handleCommentChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => onCommentChange(event.target.value),
        [onCommentChange]
    );

    return (
        <Stack spacing={2} sx={{ width: '100%', pt: 1 }}>
            <Typography variant="body2" color="text.secondary" align="center">
                {CSAT_FOLLOW_UP_TEXT[score]}
            </Typography>
            <TextField
                placeholder="Tell us more (optional)"
                multiline
                minRows={3}
                fullWidth
                value={comment}
                onChange={handleCommentChange}
                slotProps={{ htmlInput: { 'aria-label': 'Additional feedback' } }}
            />
            <Stack spacing={1}>
                <Button variant="contained" fullWidth loading={isSubmitting} onClick={onSubmit}>
                    Submit
                </Button>
                {member && score <= CSAT_LOW_SCORE_CEILING && (
                    <ScheduleCall
                        member={member}
                        ctaComponent={
                            <Button variant="text" fullWidth>
                                Prefer to talk? Schedule a call instead
                            </Button>
                        }
                    />
                )}
            </Stack>
        </Stack>
    );
}
